import React from 'react';
import './Network.css';

function Network({ language }) {
  const texts = {
    en: {
      title: 'Network',
      weiming: {
        title: 'Weiming Games',
        desc:
          'Weiming Games is the official social media channel of the Video Game and Art Research Center. As a key content outlet, it focuses on curating and recommending game studies resources and compiling materials from the Boya Annual Conference. Our audience includes professionals from the video game industry, faculty and students, and broader academic communities, with growing influence in the field of game studies.'
      },
      manual: {
        title: 'Cahiers du Jeu',
        desc:
          'Founded by our junior fellow Wang Hongzhe, "Cahiers du Jeu" advocates that games should be fun—and game studies should be engaging. Emphasizing an enthusiast culture, it publishes media articles, essays, and game criticism, bringing together game lovers, artists, and fans.'
      },
      rgm: {
        title: 'Retro Game Museum',
        desc:
          'Initiated by our junior fellow Yu Guo, the Retro Game Museum is an online space dedicated to archiving and exhibiting games in playable form. The museum houses nearly a thousand playable games from the 1970s to the present. It attempts to record and exhibit cross-regional and cross-temporal gaming nostalgia, connecting player communities through actual gameplay.'
      },
      lpim: {
        title: 'PKU Indie Game Alliance',
        desc:
          'Established under the Center, the PKU Indie Game Alliance provides Peking University students passionate about game creation with a free, professional, and collaborative platform. Bringing together students from computer science, arts, literature, psychology, and more, the Alliance supports ideation, development, and promotion through project incubation, resource integration, technical training, and showcases. We champion originality and experimentation, inspiring imagination and creativity so works with depth and distinctive aesthetics can reach a wider stage.'
      },
      labels: {
        wechat: 'WeChat',
        xhs: 'Rednote'
      }
    },
    zh: {
      title: '网络',
      subtitle: '我们的网络',
      weiming: {
        title: '未名游戏',
        desc:
          '未名游戏是游戏与艺术创研中心官方社交媒体，是中心重要的内容输出平台，目前关注于游戏研究文献推荐，博雅年会资料整理分享，覆盖电子游戏产业相关人群，在校师生和高知人群，在游戏研究领域的影响力逐渐加深。'
      },
      manual: {
        title: '游戏手册',
        desc:
          '游戏手册由中心青年研究员王洪喆老师发起，以"游戏要好玩，游戏研究也要好看"为宗旨，强调游戏研究的发烧友文化，发布游戏研究的相关媒体文章、随笔，游戏批评等内容，聚集了一批游戏发烧友、艺术家与爱好者。'
      },
      rgm: {
        title: '怀旧游戏博物馆',
        desc:
          '怀旧游戏博物馆由中心青年研究员俞果发起，是一个致力于以可玩形式档案和展陈游戏的在线空间，馆内藏有近千由上世纪七十年带至今的可玩游戏。正在尝试记录和展陈跨地区，跨时代的游戏乡愁，并以实际游玩的方式链接玩家社群。'
      },
      lpim: {
        title: '北京大学独立游戏联盟',
        desc:
          '在中心组织下成立的“北京大学独立游戏制作联盟”致力于为热爱游戏创作的北大学生提供一个自由、专业与协作共进的平台。我们汇聚来自计算机、艺术、文学、心理学等多学科背景的同学，通过项目孵化、资源整合、技术培训与展示交流等多种形式，全方位支持独立游戏的构思、开发与推广。联盟鼓励原创精神与实验探索，力求激发北大学子的想象力与创造力，助力他们将富有思想深度与美学独特性的游戏作品从校园走向更广阔的世界舞台。'
      },
      labels: {
        wechat: '微信',
        xhs: '小红书'
      }
    }
  };

  const currentTexts = texts[language];

  return (
    <div className="network-page">
      <div className="network-page-container">
        <div className="network-page-content">
          <div className="network-program-section network-program-weiming">
            <div className="network-floating-element network-top-left"></div>
            <div className="network-floating-element network-bottom-right"></div>
            <div className="network-section-container">
              <div>
                <h3 className="network-section-title">{currentTexts.weiming.title}</h3>
                <div className="network-section-content">
                  <p className="network-content-paragraph">
                    {currentTexts.weiming.desc}
                  </p>
                </div>
              </div>
              <div className="network-content-images">
                <div className="network-image-container">
                  <img
                    src={require('../assets/weimingyouxiweixin.png')}
                    alt={currentTexts.labels.wechat}
                    className="network-content-image"
                  />
                  <div className="network-image-label">
                    {/* WeChat white icon */}
                    <svg className="network-image-label-icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                      <path d="M693.12 347.264c11.776 0 23.36 0.896 35.008 2.176-31.36-146.048-187.456-254.528-365.696-254.528C163.2 94.912 0 230.656 0 403.136c0 99.52 54.272 181.248 145.024 244.736L108.8 756.864l126.72-63.488c45.312 8.896 81.664 18.112 126.912 18.112 11.392 0 22.656-0.512 33.792-1.344-7.04-24.256-11.2-49.6-11.2-76.032C385.088 475.776 521.024 347.264 693.12 347.264zM498.304 249.024c27.392 0 45.376 17.984 45.376 45.248 0 27.136-17.984 45.312-45.376 45.312-27.072 0-54.336-18.176-54.336-45.312C443.968 266.944 471.168 249.024 498.304 249.024zM244.672 339.584c-27.2 0-54.592-18.176-54.592-45.312 0-27.264 27.392-45.248 54.592-45.248S289.92 266.944 289.92 294.272C289.92 321.408 271.872 339.584 244.672 339.584zM1024 629.76c0-144.896-145.024-262.976-307.904-262.976-172.48 0-308.224 118.144-308.224 262.976 0 145.28 135.808 262.976 308.224 262.976 36.096 0 72.512-9.024 108.736-18.112l99.392 54.528-27.264-90.624C969.728 783.872 1024 711.488 1024 629.76zM616.128 584.384c-17.984 0-36.224-17.92-36.224-36.224 0-18.048 18.24-36.224 36.224-36.224 27.52 0 45.376 18.176 45.376 36.224C661.504 566.464 643.648 584.384 616.128 584.384zM815.488 584.384c-17.856 0-36.032-17.92-36.032-36.224 0-18.048 18.112-36.224 36.032-36.224 27.264 0 45.376 18.176 45.376 36.224C860.864 566.464 842.752 584.384 815.488 584.384z" fill="#ffffff"></path>
                    </svg>
                    <span>{currentTexts.labels.wechat}</span>
                  </div>
                </div>
                <div className="network-image-container">
                  <img
                    src={require('../assets/weimingyouxixiaohongshu.jpg')}
                    alt={currentTexts.labels.xhs}
                    className="network-content-image"
                  />
                  <div className="network-image-label">
                    {/* Xiaohongshu white icon */}
                    <svg className="network-image-label-icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                      <path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#FFFFFF"></path>
                      <path d="M199.936 439.04H147.456c4.608 68.352-12.288 120.064-12.288 120.064l28.16 51.456c37.376-15.872 36.608-171.52 36.608-171.52m169.984 0H317.44s-0.768 155.648 36.352 171.52l28.16-51.456c0.256 0.256-16.64-51.712-12.032-120.064M232.96 595.712H199.936c0 38.656 32.512 41.984 32.512 41.984h16.64c33.536 0 34.816-38.4 34.816-38.4v-228.352H232.96v224.768z m176.128-109.568h34.048L417.28 539.392s-15.104 29.952 9.216 30.976h56.576l22.528-41.216h-28.416c-2.56 0-4.864-2.048-4.864-4.864 0-0.768 0.256-1.536 0.512-2.048l42.24-82.944H465.92l-2.816 5.888h-3.328c-2.56 0-4.864-2.048-4.864-4.864 0-0.768 0.256-1.536 0.512-2.048l35.328-67.328h-49.152l-41.984 84.48c0.512 0-14.592 29.696 9.472 30.72m7.68 100.608s-6.4 0.512-10.496-3.584l-25.344 48.896s4.096 5.632 12.8 5.632h62.976l26.88-50.944h-66.816z" fill="#000000"></path>
                      <path d="M606.976 439.04h32.512v-52.224h-115.968v52.224h32.768v149.248h-48.64l-24.32 49.152h172.8v-49.152h-49.152v-149.248z m232.192 38.656h-5.888v-33.792c0-31.488-25.6-57.088-57.088-57.088h-19.712v-15.872h-50.176v15.872h-31.488v51.2h31.488v39.68h-50.176v51.2h50.176v109.056h50.176v-108.8h68.864c6.656 0 12.288 5.376 12.288 12.288v53.76h-47.872c0 23.808 19.2 43.008 43.008 43.008h13.056c23.808 0 43.008-19.2 43.008-43.008v-67.584c-0.256-27.904-22.272-49.92-49.664-49.92M756.48 437.76h17.92c4.352 0 7.68 3.584 7.68 7.68v32h-25.856V437.76z" fill="#000000"></path>
                      <path d="M888.064 411.904c0-13.824-11.008-24.832-24.832-24.832-13.824 0-24.832 11.008-24.832 24.832v24.832h24.832c13.568 0 24.832-11.264 24.832-24.832" fill="#000000"></path>
                    </svg>
                    <span>{currentTexts.labels.xhs}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="network-program-section network-program-manual">
            <div className="network-floating-element network-top-left"></div>
            <div className="network-floating-element network-bottom-right"></div>
            <div className="network-section-container">
              <div>
                <h3 className="network-section-title">{currentTexts.manual.title}</h3>
                <div className="network-section-content">
                  <p className="network-content-paragraph">
                    {currentTexts.manual.desc}
                  </p>
                </div>
              </div>
              <img 
                src={require('../assets/youxishouce.jpg')} 
                alt="Game Manual" 
                className="network-content-image"
              />
            </div>
          </div>

          <div className="network-program-section network-program-rgm">
            <div className="network-floating-element network-top-left"></div>
            <div className="network-floating-element network-bottom-right"></div>
            <div className="network-section-container">
              <div>
                <h3 className="network-section-title">{currentTexts.rgm.title}</h3>
                <div className="network-section-content">
                  <p className="network-content-paragraph">
                    {currentTexts.rgm.desc}
                  </p>
                  <a 
                    href="https://rgm.games" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="network-entrance-button"
                  >
                    {language === 'zh' ? '进入博物馆' : 'Enter Museum'}
                  </a>
                </div>
              </div>
              <img 
                src={require('../assets/rgmimage.png')} 
                alt="Retro Game Museum" 
                className="network-content-image"
              />
            </div>
          </div>

          <div className="network-program-section network-program-lpim">
            <div className="network-floating-element network-top-left"></div>
            <div className="network-floating-element network-bottom-right"></div>
            <div className="network-section-container">
              <div>
                <h3 className="network-section-title">{currentTexts.lpim.title}</h3>
                <div className="network-section-content">
                  <p className="network-content-paragraph">
                    {currentTexts.lpim.desc}
                  </p>
                </div>
              </div>
              <img 
                src={require('../assets/lpimimage.png')} 
                alt={currentTexts.lpim.title} 
                className="network-content-image"
              />
            </div>
          </div>

          <footer className="network-game-footer">
            <div className="network-footer-text">
              2025 Video Game and Art Research Center, Peking University
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
}

export default Network;

